import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Logo } from "./Logo";
import { api, errMsg } from "../lib/api";
import { startGoogleSignIn } from "../lib/googleAuth";
import { GoogleButton } from "./GoogleButton";

// Exchanges the one-time Google session_id (in the URL fragment) for an owner or customer session
export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);
  const [error, setError] = useState("");
  const owner = location.pathname.startsWith("/admin");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post(owner ? "/auth/google" : "/customer/session", { session_id: sessionId })
      .then(() => navigate(owner ? "/admin" : "/account", { replace: true }))
      .catch((err) => {
        window.history.replaceState(null, "", location.pathname);
        setError(errMsg(err));
      });
  }, [location.hash, location.pathname, owner, navigate]);

  if (!error) return <div className="min-h-screen bg-[#07070b]" data-testid="auth-callback" />;
  return (
    <div className="grid min-h-screen place-items-center bg-[#07070b] px-5">
      <div className="w-full max-w-md border border-white/10 bg-[#0b0b11] p-8" data-testid="auth-callback-error">
        <Logo />
        <p className="mt-6 text-[#ff7ad9]">{error}</p>
        {owner && (
          <div className="mt-6 space-y-3" data-testid="auth-callback-customer-hint">
            <p className="text-sm text-slate-300">Bought an account? Sign in on My orders to see your orders and logins.</p>
            <GoogleButton onClick={() => startGoogleSignIn("/account")} label="Go to My orders" testId="auth-callback-customer-signin" />
          </div>
        )}
        <Link to={owner ? "/admin/login" : "/account"} replace className="mt-6 inline-block font-mono text-xs uppercase tracking-widest text-slate-300 hover:text-white" data-testid="auth-callback-back">Back to sign in</Link>
      </div>
    </div>
  );
};
